
import request from '@/utils/http'
const AUTH_BASE_URL = "/api/v1";


// 买进卖出的商品
export const getUserOrder = (params) => {
    return request({
      url: `${AUTH_BASE_URL}/order_list`,
        method: 'GET',
        params
    })
}
//代购订单

export const getBehalfUserOrder = (params) => {
  return request({
    url: `${AUTH_BASE_URL}/behalf_order_list`,
      method: 'GET',
      params
  })
}
//我发布的订单

export const getReleaseListOrder = (params) => {
  return request({
    url: `${AUTH_BASE_URL}/product/releaseList`,
      method: 'GET',
      params
  })
}
//物流公司列表（国内

export const getCnLogisticsListApi = (params) => {
  return request({
    url: `${AUTH_BASE_URL}/logistics/list`,
      method: 'GET',
      params
  })
}



export const getPaypalBackApi = (params) => {
  return request({
    url: `${AUTH_BASE_URL}/paypal_back`,
      method: 'GET',
      params
  })
}

//删除商品

export const productDelOrder = (data) => {
  return request({
    url: `${AUTH_BASE_URL}/product/del`,
      method: 'POST',
      data
  })
}
//上架下架
export const productShelvesOrder = (data) => {
  return request({
    url: `${AUTH_BASE_URL}/product/shelves`,
      method: 'POST',
      data
  })
}


export const createOrderAPI = (data) => {
  return request({
    url: `${AUTH_BASE_URL}/create_order`,
      method: 'POST',
      data
  })
}
/**
 * 取消订单
 * @param {} data 
 * @returns 
 */
export const cancelOrderAPI = (data) => {
  return request({
    url: `${AUTH_BASE_URL}/cancel_order`,
      method: 'POST',
      data
  })
}
/**
 * 订单流转
 */

export const statusOrderAPI = (data) => {
  return request({
    url: `${AUTH_BASE_URL}/modify_order_status`,
      method: 'POST',
      data
  })
}

/**
 * 延迟收货
 */

export const DelayOrderAPI = (data) => {
  return request({
    url: `${AUTH_BASE_URL}/delay_order_receipt`,
      method: 'POST',
      data
  })
}
/**
 * 获取买卖订单详情
 * @param {} params 
 * @returns 
 */
export const getOrderDetailAPI = (params) => {
  return request({
    url: `${AUTH_BASE_URL}/shop_order_detail`,
      method: 'GET',
      params
  })
}

/**
 * 获取ustd支付结果
 * @param {} params 
 * @returns 
 */
export const getOrderPayResultAPI = (params) => {
  return request({
    url: `${AUTH_BASE_URL}/order/usdt_pay_result`,
      method: 'GET',
      params
  })
}
// 用户订单数

export const getUserorOdersAPI = (params) => {
  return request({
    url: `${AUTH_BASE_URL}/user_orders`,
      method: 'GET',
      params
  })
}
//获取未支付订单信
export const getUnpaidOrderDetailAPI = (params) => {
  return request({
    url: `${AUTH_BASE_URL}/unpaid_order_detail`,
      method: 'GET',
      params
  })
}
//订单支付

export const setPaymentOrderAPI = (data) => {
  return request({
    url: `${AUTH_BASE_URL}/payment_order`,
      method: 'POST',
      data
  })
}

//修改支付方式
export const setChangePayTypeAPI = (data) => {
  return request({
    url: `${AUTH_BASE_URL}/change_pay_type`,
      method: 'POST',
      data
  })
}
//获取线路信息
export const getPostageRouteAPI = (params) => {
  return request({
    url: `${AUTH_BASE_URL}/postage_route`,
      method: 'GET',
      params
  })
}
export const setPaymentOrderPostageAPI = (data) => {
  return request({
    url: `${AUTH_BASE_URL}/payment_order_postage`,
      method: 'POST',
      data
  })
}
/**
 * 切换地址
 * @param {*} data 
 * @returns 
 */
export const setChangeAddressAPI = (data) => {
  return request({
    url: `${AUTH_BASE_URL}/change_address`,
      method: 'POST',
      data
  })
}
/**
 * 取消ustd支付
 */
export const setCancelUsdtPayAPI = (data) => {
  return request({
    url: `${AUTH_BASE_URL}/order/cancel_usdt_pay`,
      method: 'POST',
      data
  })
}

/**
 * 获取支付方式
 * @param {*} params 
 * @returns 
 */
export const getPaymentMethodsAPI = (params) => {
  return request({
    url: `${AUTH_BASE_URL}/pay/list`,
      method: 'GET',
      params
  })
}
/**
 * 获取物流信息
 * @param {} params 
 * @returns 
 */
export const getLogisticsTrackAPI = (params) => {
  return request({
    url: `${AUTH_BASE_URL}/logistics/track`,
      method: 'GET',
      params
  })
}

/**
 * 修改物流单号
 * @param {} data 
 * @returns 
 */
export const setUpdataShippingNumberAPI = (data) => {
  return request({
    url: `${AUTH_BASE_URL}/modify_shipping_number`,
      method: 'POST',
      data
  })
}